<template>
  <div class="credential">
      <Login v-if="showCred == 'login'"/>
      <Register v-if="showCred == 'register'"/>
      <Forgot v-if="showCred == 'forgot'"/>
      <div class="overlay" @click="close"></div>
  </div>
</template>

<script>
import Login from '@/Components/Login.vue'
import Register from '@/Components/Register.vue'
import Forgot from '@/Components/ForgotPassword.vue'
export default {
    components:{
        Login,
        Register,
        Forgot
    },

    data(){
        return{

        }
    },

    computed: {
        showCred(){
            return this.$store.state.showCred
        }
    },

    methods:{
        close(){
            this.$store.commit('setCred', null)
        }
    }
};
</script>

<style scoped>
  .overlay{
    position: fixed;
    top:0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 299;
    background: rgba(0, 0, 0, 0.3);
  }
    
</style>


// WEBPACK FOOTER //
// src/Components/Credential.vue